import React from 'react';
import {motion} from 'framer-motion';
import { useState } from 'react';
const Contact = () => {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const handleContactForm = (e) =>{
    e.preventDefault()
  }
  return <section className="contact">
    <div className="contactContainer">
        <form className="contactForm" onSubmit={handleContactForm}>
            <p>CONTACT US</p>
            <input type="text" placeholder='Name' onChange={(e)=>setName(e.target.value)}/>
            <input type="email" placeholder='Email' onChange={(e)=>setEmail(e.target.value)}/>
            <textarea cols="30" rows="10" placeholder='Message...' onChange={(e)=>setMessage(e.target.value)}></textarea>
            <input type="submit" value="Send" />
        </form>
        <motion.div initial={{x:"100vw"}} animate={{x:0}} transition={{ delay: 0.2 }}>
            <motion.img initial={{y:"-100vh"}} animate={{y:0}} transition={{delay:0.5}} src="/tangyuan.png" alt="tangyuan" />
        </motion.div>
    </div>
  </section>
}

export default Contact